import { Box, Button, Dialog, IconButton, Typography } from "@mui/material";
import UploadFileIcon from "../assets/images/Icon-UploadSimple.svg";
import PlayVideoIcon from "../assets/images/octicon_play-24.svg";
import tickMark from "../assets/images/Icon-Check.svg";
import DeleteIcon from "../assets/images/Delete.svg";
import BackwardIcon from "../assets/images/Group 1561530081.svg";
import ForwardIcon from "../assets/images/Group 1561530080.svg";
import ResumeIcon from "../assets/images/Group 1561530073.svg";
import PauseIcon from "../assets/images/Group 1561530101.svg";
import CloseIcon from "@mui/icons-material/Close";
import { useContext, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { EventFormContext } from "../context/EventFormContext";
import useAutoHideControls from "../hooks/useAutoHideControls";
import {
  describeAllowed,
  getAllowedFormats,
  isAllowedUpload,
  withUploadMimeType,
} from "../helpers/eventUploadFormats";

const decodeStoredFileName = (name) => {
  try {
    return decodeURIComponent(name);
  } catch {
    // Raw filenames can contain a literal percent sign rather than an escape.
    return name;
  }
};

const FileUpload = ({
  eventType,
  formData,
  setFormData,
  handleVideoChange,
  file,
  edit,
  eventId,
  disabled,
  hideDelete,
}) => {
  console.log("event type is", eventType);
  console.log("file in line 26 is", file);
  console.log("form data in File Upload page is", formData);
  const [videoUrl, setVideoUrl] = useState("");
  const [openVideoModal, setOpenVideoModal] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [dragOver, setDragOver] = useState(false);
  const { setUpdatedFields } = useContext(EventFormContext);
  const [showIcons, resetControls] = useAutoHideControls(isPlaying, 3000);

  const videoRef = useRef(null);

  const handleClose = () => {
    videoRef.current?.pause();
    setOpenVideoModal(false);
    setIsPlaying(false);
    resetControls();
  };

  const handleSkip = (seconds) => {
    if (videoRef.current) {
      videoRef.current.currentTime += seconds;
    }
  };

  const handleTogglePlayPause = () => {
    const video = videoRef.current;

    if (video) {
      if (isPlaying) {
        video.pause();
      } else {
        video.play();
      }
      setIsPlaying(!isPlaying);
    }
  };
  /**
   * The one place a chosen file is validated, for both the picker and the drop
   * zone. They used to diverge: the picker validated nothing and the drop zone
   * compared the joined `accept` string to a single MIME type.
   */
  const acceptFile = (candidate) => {
    // The picker fires change with no file when the dialog is cancelled, and
    // URL.createObjectURL throws on undefined.
    if (!candidate) return;
    if (!isAllowedUpload(eventType, candidate)) {
      alert(
        `That file type is not supported here. Please upload ${describeAllowed(eventType)}.`,
      );
      return;
    }
    const uploadFile = withUploadMimeType(candidate);
    handleVideoChange(uploadFile);
    setVideoUrl(URL.createObjectURL(uploadFile));
  };

  const handleDelete = () => {
    setFormData((prevFormData) => ({ ...prevFormData, resourceFile: null }));
    setUpdatedFields((prevFormData) => ({
      ...prevFormData,
      resourceFile: null,
    }));
  };

  const editVideoUrl = formData?.resourceFile?.url || "";
  const editVideoName = formData?.resourceFile?.fileName || "";
  const displayFileName = decodeStoredFileName(editVideoName) || file?.name;
  const editVideoSize = formData?.resourceFile?.fileSize || "";
  const IS_PDF = file?.type === "application/pdf" || file?.fileType === ".pdf";
  return (
    <>
      {!file && (
        <Box
          sx={{
            border: "2px solid #AAB6C8",
            padding: "7px",
            ...(disabled && { cursor: "not-allowed" }),
          }}
        >
          <Box
            sx={{
              border: "2px dashed #AAB6C8",
              display: "flex",
              padding: "11px",
              justifyContent: "space-between",
              alignItems: "center",
              backgroundColor: dragOver ? "#f0f0f0" : "transparent",
              gap: "5px",
            }}
            onDragOver={(e) => {
              if (disabled) return;
              e.preventDefault();
              setDragOver(true);
            }}
            onDragLeave={() => setDragOver(false)}
            onDrop={(e) => {
              e.preventDefault();
              setDragOver(false);
              // Only the hidden input carried `disabled`, so a disabled upload
              // still accepted a drop.
              if (disabled) return;
              acceptFile(e.dataTransfer.files[0]);
            }}
          >
            <Box
              sx={{
                width: "50px",
                height: "50px",
                borderRadius: "50%",
                backgroundColor: "#EBEBEB",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img src={UploadFileIcon} />
            </Box>
            <Typography sx={{ fontSize: "11px" }}>
              Choose a Video or PDF file, or drag & drop here
            </Typography>
            <input
              type="file"
              hidden
              id="fileUpload"
              disabled={disabled}
              accept={getAllowedFormats(eventType)}
              onChange={(e) => acceptFile(e.target.files[0])}
            />
            <label htmlFor="fileUpload">
              <Button
                component="span"
                variant="outlined"
                sx={{
                  textTransform: "capitalize",
                  color: "black",
                  width: "8vw",
                  borderRadius: "15px",
                  borderColor: "gray",
                  fontWeight: "Bold",
                  ...(disabled && { cursor: "not-allowed" }),
                }}
              >
                Select File
              </Button>
            </label>
          </Box>
        </Box>
      )}
      {eventType !== "Articles and Blogs" &&
        eventType !== "articles-and-blogs" &&
        file &&
        !IS_PDF && (
          <Box
            sx={{
              backgroundColor: "#F5F5F5",
              height: "10vh",
              borderRadius: "12px",
              padding: "10px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "space-between",
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "row", gap: "8px" }}>
              <Box
                sx={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  display: "flex",
                  justifyContent: "center",
                  backgroundColor: "#EBEBEB",
                  alignItems: "center",
                }}
              >
                <img
                  src={PlayVideoIcon}
                  onClick={() => setOpenVideoModal(true)}
                  style={{ cursor: "pointer" }}
                />
              </Box>
              <Box>
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontWeight: "bold",
                    color: "#595959",
                  }}
                >
                  {displayFileName}
                </Typography>
                <bold
                  style={{
                    fontSize: "10px",
                    display: "flex",
                  }}
                >
                  {((editVideoSize || file.size) / 1024 / 1000).toFixed(1)} MB
                </bold>
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img src={tickMark} style={{ width: "5vw", height: "5vh" }} />
              {!hideDelete && (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    backgroundColor: "white",
                    width: "45px",
                    height: "45px",
                    borderRadius: "50%",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <img
                    src={DeleteIcon}
                    onClick={handleDelete}
                    style={{
                      height: "4.5vh",
                      width: "4.5vw",
                      cursor: "pointer",
                    }}
                  />
                </Box>
              )}
            </Box>

            <Dialog
              open={openVideoModal}
              onClose={handleClose}
              maxWidth="md"
              fullWidth
              PaperProps={{
                sx: {
                  width: "600px",
                  height: "350px",
                  position: "relative",
                  //overflow: 'hidden',
                },
              }}
            >
              {openVideoModal && (
                <Box
                  sx={{
                    position: "absolute",
                    top: "5px",
                    right: "5px",
                    zIndex: "999",
                  }}
                >
                  {console.log("oopen video modal is", openVideoModal)}
                  <IconButton
                    aria-label="close"
                    //className={classes.closeButton}
                    sx={{ backgroundColor: "#00000040" }}
                    onClick={handleClose}
                  >
                    <CloseIcon />
                  </IconButton>
                </Box>
              )}
              <video
                src={videoUrl || editVideoUrl}
                controls
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  display: "block",
                }}
                ref={videoRef}
                autoPlay
                onPlay={() => setIsPlaying(true)}
                onPause={() => {
                  setIsPlaying(false);
                  resetControls();
                }}
              ></video>

              {showIcons && (
                <>
                  <img
                    src={BackwardIcon}
                    onClick={() => handleSkip(-10)}
                    style={{
                      width: "25px",
                      height: "25px",
                      position: "absolute",
                      top: "50%",
                      left: "30%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                    }}
                  />
                  <img
                    src={isPlaying ? PauseIcon : ResumeIcon}
                    onClick={handleTogglePlayPause}
                    style={{
                      width: "25px",
                      height: "25px",
                      position: "absolute",
                      top: "50%",
                      left: "48%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                    }}
                  />
                  {/* Forward Button */}
                  <img
                    src={ForwardIcon}
                    onClick={() => handleSkip(10)}
                    style={{
                      width: "25px",
                      height: "25px",
                      position: "absolute",
                      top: "50%",
                      left: "65%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                    }}
                  />
                </>
              )}
            </Dialog>
          </Box>
        )}
      {(eventType === "Articles and Blogs" ||
        eventType === "articles-and-blogs" ||
        IS_PDF) &&
        file && (
          <>
            <Box
              sx={{
                borderRadius: "15px",
                padding: "15px",
                display: "flex",
                justifyContent: "space-between",
                backgroundColor: "#EBEBEB",
                alignItems: "center",
                gap: "2px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  gap: "4px",
                  alignItems: "flex-start",
                  fontSize: "14px",
                }}
              >
                <Link
                  to="/events/view-pdf"
                  onClick={() =>
                    setFormData((prevFormData) => ({
                      ...prevFormData,
                      linkClicked: true,
                    }))
                  }
                  style={{
                    textAlign: "left",
                    display: "inline-block",
                    whiteSpace: "nowrap",
                    width: "80%",
                    textOverflow: "ellipsis",
                    overflow: "auto",
                  }}
                  state={
                    edit ? { mode: "edit", eventId: eventId } : { mode: "view" }
                  }
                >
                  {displayFileName}
                </Link>
                <bold
                  style={{
                    fontSize: "13px",
                    display: "flex",
                  }}
                >
                  {((editVideoSize || file.size) / 1024 / 1000).toFixed(1)} MB
                </bold>
              </Box>
              {!hideDelete && (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    backgroundColor: "white",
                    width: "45px",
                    height: "45px",
                    borderRadius: "50%",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <img
                    src={DeleteIcon}
                    onClick={handleDelete}
                    style={{
                      height: "4.5vh",
                      width: "4.5vw",
                      cursor: "pointer",
                    }}
                  />
                </Box>
              )}
            </Box>
          </>
        )}
    </>
  );
};
export default FileUpload;
